var _rect, _g, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmarkFilledPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Realistic Interview"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1256,
    transform: "translate(-438 -207)",
    fill: "#F5F6F7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\xC2\xB7-Forms-\xE8\xA1\xA8\xE5\x8D\x95\xE9\xA1\xB5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE8\xA1\xA8\xE5\x8D\x95\xE9\xA1\xB5/\xE5\x9F\xBA\xE7\xA1\x80\xE8\xA1\xA8\xE5\x8D\x95/\xE6\x8F\x8F\xE8\xBF\xB0\xE8\xA1\xA8\xE5\x8D\x95Kit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M973.167 -89H-409.167C-411.836 -89 -414 -82.5857 -414 -74.6732V992.673C-414 1000.59 -411.836 1007 -409.167 1007H973.167C975.836 1007 978 1000.59 978 992.673V-74.6732C978 -82.5857 975.836 -89 973.167 -89Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 95",
    x: -414,
    y: 7,
    width: 1392,
    height: 1000,
    rx: 10,
    fill: "url(#paint0_linear_89_353)",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("g", {
    id: "-"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE7\x9F\xA9\xE5\xBD\xA2",
    d: "M38.3698 -32H-386.37C-388.375 -32 -390 -30.0009 -390 -27.5349V59.5349C-390 62.0009 -388.375 64 -386.37 64H38.3698C40.3747 64 42 62.0009 42 59.5349V-27.5349C42 -30.0009 40.3747 -32 38.3698 -32Z",
    fill: "#F5F6F7",
    stroke: "url(#paint1_linear_89_353)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-\xE5\x9B\xBE\xE6\xA0\x87/Status/checkmark--filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9925 6.96663L7.60125 12.3585C7.50375 12.456 7.345 12.456 7.2475 12.3585L4.5075 9.61851C4.41 9.52038 4.41 9.36226 4.5075 9.26476L5.0375 8.73476C5.13562 8.63663 5.29375 8.63663 5.39125 8.73476L7.42438 10.7679L12.1088 6.08288C12.2063 5.98538 12.3644 5.98538 12.4619 6.08288L12.9925 6.61351C13.09 6.71101 13.09 6.86913 12.9925 6.96663ZM8.75 0.249756C3.925 0.249756 0 4.17476 0 8.99976C0 13.8248 3.925 17.7498 8.75 17.7498C13.575 17.7498 17.5 13.8248 17.5 8.99976C17.5 4.17476 13.575 0.249756 8.75 0.249756Z",
    fill: "#423ED8"
  }))))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 94",
    x: -708,
    y: -483,
    width: 4946,
    height: 3046,
    stroke: "#423ED8",
    strokeWidth: 26
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_89_353",
    x1: 282,
    y1: 1007,
    x2: 282,
    y2: 7.00001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#423ED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_89_353",
    x1: 41291.7,
    y1: 4911.04,
    x2: 2454.86,
    y2: -1140.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#457AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423ED8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkFilledPurple);
export default __webpack_public_path__ + "static/media/checkmark--filled-purple.00d40e1cbfae1f524e5909b4a47f35a3.svg";
export { ForwardRef as ReactComponent };